import BlueSkyRules from './BlueSkyRules';

export default BlueSkyRules;
